import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { hideToastMessage } from 'fitbeat.react-native-components';

class RightToastMessage extends Component {
    componentWillUnmount = () => {
        this.props.hideToast();
    }

    render() {
        return (
            <div>
                {this.props.toast &&
                    ReactDOM.createPortal(
                        <div style={{
                            textAlign: "center",
                            verticalAlign: "middle",
                            paddingTop: '30vh',
                            backgroundColor: 'white',
                            height: '100%'}}>
                            {this.props.toast.icon}
                            {this.props.toast.text}
                        </div>, document.getElementById('right-content'))
                }
            </div>
        );
    }
}

export default connect(state => {
    return {
        toast: state.ui.toast
    };
}, (dispatch) => {
    return {
        hideToast: () => dispatch(hideToastMessage()),
    }
})(RightToastMessage);
